export const PROFILE_THEME = {
  white: '#FFFFFF',
  success: '#00B83E',
  successBg: '#00B83E33',
  error: '#DE2E07',
  errorBg: '#DE2E0733',
  pending: '#F0C018',
  pendingBg: '#F0C01833',
  color1: '#1C1C1E',
  color2: '#8E8E93',
  color3: '#000000',
  color4: '#FFFFFF',
  color5: '#FFFFFF',
  color7: '#FFFFFF',
  color9: '#9A9CAC',
  color10: '#42C7F3',
  color11: '#25AAD6',
  color12: '#000000',
  color20: '#636366',
  color22: '#FFFFFF',
  color23: '#FFFFFF',
  color24: '#1AB232',
  color25: '#EA5B0C',
  color27: '#FF7226',
  color32: '#25AAD6',
  color33: '#FFFFFF',
  color38: '#636366',
  color41: '#000000',
  color43: '#FFFFFF33',
  borderRadius1: '360px',
  borderRadius2: '24px',
};

const theme = {
  ...PROFILE_THEME,
  mainColor: '#EA5B0C',
  mainColorHover: '#FF7226',
  mainColorActive: '#E35202',
  secondaryColor: '#25AAD6',
  secondaryColorHover: '#42C7F3',
  secondaryColorActive: '#028EBC',
  whiteColor: '#FFFFFF',
  blackColor: '#000000',
  blackLightColor: '#8E8E93',
  charcoal: '#0F0F0F',
  solarYellow: '#ffe242',
  flameOrange: '#ea5b0c',
  grayColor: '#636366',
  grayDarkColor: '#1c1c1e',
  grayLightColor: '#1c1c1e',
  grayMegaLightColor: '#D3D3D9',
  gray1Color: '#F2F2F4',
  redColor: '#DE2E07',
  redColor1: '#FA5050',
  brownColor: '#5C3A0B',
  greenLightColor: '#00aa09',
  orangeColor: '#ff412b',
  amberOrange: '#FFAA3C',
  greenColor: '#1AB232',
  green2Color: '#00CC88',
  green3Color: '#218D52',
  green4Color: '#0D3B02',
  green5Color: '#1C500F',
  violetColor: '#4F219A',
  goldColor: '#B16800',
  amberGold: '#DF9E2D',
  yellowColor: '#F0C018',
  yellow1Color: '#FFD500',
  yellow2Color: '#ffe225',
  yellow3Color: '#ffeb7d',
  highlightYellow: '#FB9A00',
  amberYellow: '#FCD013',
  lightBlue: '#4F79AB',
  blueSky: '#56A2E3',
  midnightBlue: '#00165C',
  violetBlue: '#0A0B37',
  darkIndigo: '#292A4F',
  nightBlue: '#090E4E',
  royalBlue: '#2A2D8F',
  cedarWoodColor: '#821F00',
  picassoColor: '#FFEC93',
  yellowSeaColor: '#FFAD01',
  lightVioletColor: '#854DEB',
  sandGold: '#C0A65A',
  sandGoldLight: '#D6C07E',
  manateeColor: '#8E8E93',
  softCoral: '#E78585',
  mintGreen: '#7AD6B1',
  brightGreen: '#1AB23E',
  blushPink: '#F3B6DB',
  goldenCream: '#E7DA85',
  sunshineYellow: '#FFEA7D',
  skeletonDarkBackgroundColor: '#1C1C1E',
  skeletonDarkForegroundColor: '#131314',
  skeletonLightBackgroundColor: '#D3D3D9',
  skeletonLightForegroundColor: '#F2F2F4',

  greenSuccessColor: '#1AB232',
  vipSuper1: '#00C4FF',
  vipSuper2: '#6416E7',
  vipSuper3: '#F13494',

  // gradient
  goldGradient: 'linear-gradient(90deg, #BD5D0D 0%, #FFEC93 50%, #BD5D0D 100%)',
  darkGoldGradient: 'linear-gradient(180deg, #ffeb7d 5.44%, #bf610f 99.56%)',
  goldLightGradient: 'linear-gradient(0deg, #FFAD01 0%, #FFD500 100%)',
  goldenOrangeGradient: 'linear-gradient(90deg, #FF7B00 0%, #FFCB00 100%)',
  freshLimeGradint: 'linear-gradient(90deg, #1AB232 19.02%, #93DB37 81.48%)',
  solarFlareGradient: 'linear-gradient(90deg, #FFAD01 19.02%, #FFD500 81.48%)',
  goldDarkGradient: 'linear-gradient(180deg, #FFEA7D 0%, #FFD500 100%)',
  blackGradient:
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 40%, #000 100%)',
  secondaryGreenGradient: 'linear-gradient(90deg, #00B83E 0%, #00B67D 100%)',
  greenLightGradient:
    'linear-gradient(180deg, #CFFC94 0%, #58CE35 50%, #088717 100%)',
  greenDarkGradient:
    'linear-gradient(180deg, #D0FD95 0%, #58CE35 50%, #58CE35 100%)',
};

export default theme;
